var STORAGE_PREFIX = 'ECRION_STORE:';
export var loadFromStorage = function loadFromStorage(key, defaultValue) {
  var val = localStorage.getItem(STORAGE_PREFIX + key);
  if (!val) return defaultValue;
  return val;
};
export var saveToStorage = function saveToStorage(key, value) {
  localStorage.setItem(STORAGE_PREFIX + key, value);
};
export default {};